import serverService from "@/services/server";

export const state = {
  loading: false,
  servers: [],
};

export const actions = {
  getServers({ commit }) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      serverService
        .getServers()
        .then((data) => {
          resolve(data);
          commit("setServers", data.data.data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
          commit("setLoading", false);
        });
    });
  },
};

export const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setServers(state, payload) {
    state.servers = payload;
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  getServer(state) {
    return state.servers;
  },
};
